import { OLD_EMAIL } from "services/types";
import { init, success, update, finish, error, reset } from "services/common";
import { OldEmailServices } from "./api";

const oldEmailServices = new OldEmailServices();

export const actionForOldEmailPaginaton = (payload, param) => {
  return async (dispatch) => {
    dispatch(init(OLD_EMAIL.OLD_EMAIL_PAGINATION));
    const response = await oldEmailServices.apiForOldEmailPagination(
      payload,
      param
    );
    if (response?.isSuccess) {
      dispatch(success(OLD_EMAIL.OLD_EMAIL_PAGINATION, response?.data));
      dispatch(finish(OLD_EMAIL.OLD_EMAIL_PAGINATION));
    } else if (!response.isSuccess) {
      dispatch(error(response?.errorMessage));
    }
  };
};

export const actionForGetOldEmailDetail = (id, payload) => {
  return async (dispatch) => {
    dispatch(init(OLD_EMAIL.OLD_EMAIL_DEATAIL));
    const response = await oldEmailServices.apiForGetEmailDetail(id, payload);
    if (response?.isSuccess) {
      dispatch(success(OLD_EMAIL.OLD_EMAIL_DEATAIL, response?.data));
      dispatch(finish(OLD_EMAIL.OLD_EMAIL_DEATAIL));
    } else if (!response.isSuccess) {
      dispatch(error(response?.errorMessage));
    }
  };
};
export const resetOldMailDetail = () => {
  return {
    type: OLD_EMAIL.OLD_EMAIL_DEATAIL_RESET,
  };
};
